// extracted by mini-css-extract-plugin
export default {"root":"skeleton_root__HlUSb"};